
import { setCookieValue, removeCookieValue } from "~/utils/cookie";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";

const datadogErrorUrl = "datadog/events/error";

export default {
  name: "cal-sign-in",
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      recoveryEmail: "",
      disableSignIn: true,
      disableForgotPassword: true,
      isForgotPassword: false,
      isRecoveryRequest: false,
      isRecoveryRequestSuccess: false,
      showAlert: false,
      alertMessage: "",
    };
  },
  mixins: [ProcessLineItemsMixin],
  created() {
    removeCookieValue("CAL_ACCESS_TOKEN");
  },
  methods: {
    isEmailValid(email) {
      const regex =
        /^(?=^.{8,}$)[-_A-Za-z0-9]+([_.-][a-zA-Z0-9]+)*@[A-Za-z0-9]+([.-][a-zA-Z0-9]+)*\.[A-Za-z]{2,}$/;
      return regex.test(email);
    },
    validateUserNameAndPassword() {
      if (this.form.email && this.isEmailValid(this.form.email) && this.form.password) {
        this.disableSignIn = false
      } else {
        this.disableSignIn = true
      }
    },
    validateRecoveryEmail() {
      if (this.recoveryEmail && this.isEmailValid(this.recoveryEmail)) {
        this.disableForgotPassword = false
      } else {
        this.disableForgotPassword = true
      }
    },
    async signIn() {
      try {
        let userSignInCread = {
          email: this.form.email.toLowerCase(),
          password: this.form.password,
        };
        let user = await this.$store.dispatch(
          "account/SIGN_IN",
          userSignInCread
        );

        setCookieValue(
          "CAL_ACCESS_TOKEN",
          user.signInUserSession.idToken.jwtToken
        );
        this.$emit("signedIn");
      } catch (error) {
        const err = error.toString()
        if (err.includes("UserNotFoundException")) {
          this.showAlert = true;
          this.alertMessage = this.$t("alert_message_incorrect_user_name");
        } else if (err.includes("NotAuthorizedException")) {
          this.showAlert = true;
          this.alertMessage = this.$t("alert_message_incorrect_user_pass");
        } else if (err.includes("PasswordResetRequiredException")) {
          this.showAlert = true;
          this.recoveryEmail = this.form.email.toLowerCase()
          await this.forgotPassword()
          this.alertMessage = this.$t("alert_message_pass_reset");
        } else {
          this.showAlert = true;
          this.alertMessage = this.$t("alert_message_signin_error");
          await this.$axios.$post(datadogErrorUrl, {error: {"name": "USER-CANT-SIGNIN", "ddSessionId": this.getatadogSessionID()}}, {});
          console.log("Error signing in", error);
        }
      }
    },
    async forgotPassword() {
      try {
        let response = await this.$store
          .dispatch("account/FORGOT_PASSWORD", this.recoveryEmail.toLowerCase())
          .then((data) => {
            this.isRecoveryRequest = true;
            this.isRecoveryRequestSuccess = true;
          });
      } catch (error) {
        this.isRecoveryRequestSuccess = false;
        const err = error.toString()
        if (err.includes("UserNotFoundException")) {
          this.showAlert = true;
          this.alertMessage = this.$t("alert_message_incorrect_user_name");
        } else {
          this.showAlert = true;
          this.alertMessage = this.$t("alert_message_signin_error");
          console.log("error recovering password", error);
        }
      }
    },
  },
};
